import { Component } from '@angular/core';
import { LoginService } from "app/services/login/login.service";

@Component({
  selector: 'app-liquidaciones',
  templateUrl: './liquidaciones.component.html',
  styleUrls: ['./liquidaciones.component.scss']
})
export class LiquidacionesComponent   {

  constructor(private loginService:LoginService) { }

  

  
  clickGuard(){
    this.loginService.clickGuard = true;
 }

}
